import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./style.css";
import noop from "lodash/noop";

import { BundleRegistry, Bundle } from "components/Bundle";
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { Prompt } from "react-router";

import AppMenuAndFrame from "views/AppMenuAndFrame";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import SavePocketmodDialog from "components/ui/SavePocketmodDialog";
import AdPopup from "components/ui/AdPopup";

const bundles = {
  HomePage: () => import("views/HomePage"),
  Builder: () => import("views/Builder"),
  PrintPage: () => import("views/PrintPage"),
  SavedMods: () => import("views/SavedMods"),
  HowTo: () => import("views/HowTo"),
  Privacy: () => import("views/Privacy"),
  ShopView: () => import("views/ShopView"),
  News: () => import("views/News"),
  Community: () => import("views/Community"),
  Admin: () => import("views/Admin"),
  DebugView: () => import("views/DebugView"),
  Finished: () => import("views/Finished"),
};

const navigateTo = (history, whereTo) => {
  history.push(whereTo);
};

const AppButtonBar = (props) => {
  return <div {...props} className="app-button-bar" />;
};

const socialMediaButtonBar = ({ Button, FacebookButton }) => {
  return (
    <AppButtonBar>
      <FacebookButton width={20} />
    </AppButtonBar>
  );
};

class component extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.state = {
      alert: {
        modal: false,
        open: false,
        label: "Close",
        onClick: this.handleClose,
        onRequestClose: this.handleClose,
        children: "Alert!",
      },
      save: {
        open: false,
      },
    };
  }

  componentDidMount() {
    this.props.init();
  }

  handleSave() {
    this.setState((prev) => {
      return {
        save: { ...prev.save, open: true },
      };
    });
  }

  handleClose() {
    this.setState((prev) => {
      return {
        alert: { ...prev.alert, open: false },
        save: { ...prev.save, open: false },
      };
    });
  }

  alert(message) {
    this.showAlert({ children: message });
  }

  showAlert(options) {
    const actions = [<FlatButton label="Close" primary={true} onClick={this.handleClose} />];
    this.setState((prev) => {
      return {
        alert: { ...prev.alert, actions, open: true, ...options },
      };
    });
  }

  render() {
    const hasSubscription = this.props.hasSubscription;
    const subscriptionReady = this.props.subscriptionReady;
    return (
      <div>
        <BundleRegistry registry={bundles}>
          <Router>
            <div className="AppRoot">
              <Route
                path="/"
                exact
                render={({ match, location, history }) => {
                  return (
                    <AppMenuAndFrame onNavigate={navigateTo.bind(this, history)} renderButtonBar={socialMediaButtonBar}>
                      <Bundle
                        name="HomePage"
                        onNavigate={navigateTo.bind(this, history)}
                        hasSubscription={hasSubscription}
                        subscriptionReady={subscriptionReady}
                      />
                    </AppMenuAndFrame>
                  );
                }}
              />
              <Route
                path="/logout"
                render={({ match, location, history }) => {
                  this.props.logout();
                  return <Redirect to="/" />;
                }}
              />
              <Route
                path="/admin"
                render={({ match, location, history }) => {
                  if (!this.props.isAdmin) {
                    return (
                      <a onClick={navigateTo.bind(this, history, "/build")} href="#">
                        build
                      </a>
                    );
                  }
                  return (
                    <AppMenuAndFrame scroll={true} title={title("Admin")} onNavigate={navigateTo.bind(this, history)} renderButtonBar={socialMediaButtonBar}>
                      <Bundle name="Admin" />
                    </AppMenuAndFrame>
                  );
                }}
              />
              <Route
                path="/debug"
                render={({ match, location, history }) => {
                  return <Bundle name="DebugView" />;
                }}
              />
              <Route
                path="/howto"
                render={({ match, location, history }) => {
                  return (
                    <AppMenuAndFrame scroll={true} title={title("How To")} onNavigate={navigateTo.bind(this, history)} renderButtonBar={socialMediaButtonBar}>
                      <Bundle name="HowTo" />
                    </AppMenuAndFrame>
                  );
                }}
              />
              <Route
                path="/privacy"
                render={({ match, location, history }) => {
                  return (
                    <AppMenuAndFrame scroll={true} title={title("Privacy")} onNavigate={navigateTo.bind(this, history)} renderButtonBar={socialMediaButtonBar}>
                      <Bundle name="Privacy" />
                    </AppMenuAndFrame>
                  );
                }}
              />
              <Route
                path="/shop"
                render={({ match, location, history }) => {
                  return (
                    <AppMenuAndFrame scroll={true} title={title("Store")} onNavigate={navigateTo.bind(this, history)} renderButtonBar={socialMediaButtonBar}>
                      <Bundle name="ShopView" />
                    </AppMenuAndFrame>
                  );
                }}
              />
              <Route
                path="/news"
                render={({ match, location, history }) => {
                  return (
                    <AppMenuAndFrame scroll={true} title={title("News")} onNavigate={navigateTo.bind(this, history)} renderButtonBar={socialMediaButtonBar}>
                      <Bundle name="News" />
                    </AppMenuAndFrame>
                  );
                }}
              />
              <Route
                path="/community"
                render={({ match, location, history }) => {
                  return (
                    <AppMenuAndFrame
                      scroll={true}
                      title={title("Community")}
                      onNavigate={navigateTo.bind(this, history)}
                      renderButtonBar={socialMediaButtonBar}
                    >
                      <Bundle name="Community" />
                    </AppMenuAndFrame>
                  );
                }}
              />
              <Route
                path="/link"
                render={({ match, location, history }) => {
                  this.props.link();
                  return <Redirect to="/" />;
                }}
              />
              <Route
                path="/print/:id?/:temp?"
                render={({ match, location, history }) => {
                  const modId = match.params.id;
                  const temp = match.params.temp === "temp";
                  return (
                    <Bundle
                      name="PrintPage"
                      modId={modId}
                      loadFromTemp={temp}
                      onFailToLoad={() => {
                        console.error("failed to load mod");
                      }}
                    />
                  );
                }}
              />
              <Route
                path="/build/:id?"
                render={({ match, location, history }) => {
                  if (!this.props.isLoggedIn) {
                    return null;
                  }
                  const modId = match.params.id;
                  return (
                    <AppMenuAndFrame
                      title={title("Build")}
                      onNavigate={navigateTo.bind(this, history)}
                      renderButtonBar={({ Button, PrimaryButton, MenuItem, Menu }) => {
                        return (
                          <AppButtonBar>
                            <Menu>
                              <MenuItem
                                primaryText="Clear Mod"
                                onClick={() => {
                                  this.props.newEmptyMod();
                                  history.push(`/build`);
                                }}
                              />
                              {this.props.hasSubscription ? (
                                <MenuItem
                                  primaryText="My Saves / PDF Converter"
                                  onClick={() => {
                                    history.push(`/my-saves`);
                                  }}
                                />
                              ) : null}
                            </Menu>
                            <Button label="Save" onClick={this.handleSave.bind(this)} />
                            <PrimaryButton
                              label="Print"
                              onClick={() => {
                                modId ? history.push(`/print/${modId}`) : history.push(`/print`);
                              }}
                            />
                          </AppButtonBar>
                        );
                      }}
                    >
                      <Bundle
                        name="Builder"
                        modId={modId}
                        onFailToLoad={() => {
                          history.replace("/build");
                        }}
                      />
                      <SavePocketmodDialog
                        hasSubscription={this.props.hasSubscription}
                        name={this.props.name}
                        desc={this.props.desc}
                        open={this.state.save.open}
                        onClose={this.handleClose.bind(this)}
                        onSubmit={(vals) => {
                          this.props.savePocketmod({
                            modId,
                            onSuccess: (id) => {
                              this.alert("Saved!");
                              history.replace(`/build/${id}`);
                            },
                            ...vals,
                          });
                        }}
                      />
                      {!this.props.hasSubscription ? <AdPopup /> : null}
                      <Prompt
                        message={(location) => {
                          // console.log(location, modId, this.props.isModDirty)
                          if (modId && this.props.isModDirty) {
                            return "You have unsaved changes that will be discarded. Continue?";
                          }
                          return true;
                        }}
                      />
                    </AppMenuAndFrame>
                  );
                }}
              />
              <Route
                path="/finished"
                render={({ match, location, history }) => {
                  return (
                    <AppMenuAndFrame title={title("My Saves")} onNavigate={navigateTo.bind(this, history)}>
                      <Bundle name="Finished" />
                    </AppMenuAndFrame>
                  );
                }}
              />
              <Route
                path="/my-saves"
                render={({ match, location, history }) => {
                  if (!this.props.subscriptionReady) {
                    return null;
                  }
                  if (!this.props.hasSubscription) {
                    return <Redirect to="/shop" />;
                  }
                  return (
                    <AppMenuAndFrame title={title("My Saves")} onNavigate={navigateTo.bind(this, history)}>
                      <Bundle
                        name="SavedMods"
                        onSelectDataMod={(item) => {
                          history.push(`/build/${item.id}`);
                        }}
                      />
                    </AppMenuAndFrame>
                  );
                }}
              />
            </div>
          </Router>
        </BundleRegistry>
        <Dialog {...this.state.alert} />
      </div>
    );
  }
}

component.propTypes = {
  init: PropTypes.func,
  savePocketmod: PropTypes.func,
  newEmptyMod: PropTypes.func,
};

component.defaultProps = {
  init: noop,
  savePocketmod: noop,
  newEmptyMod: noop,
};

export default component;

function title(txt) {
  return `Pocketmod : ${txt}`;
}



// WEBPACK FOOTER //
// ./src/views/AppRoot/component.js